/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { Trans, translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

type TypeProps = {|
  location: Object,
|};

type InjectedProps = {
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class MarkAsDefaultLocationError extends ComponentWithInjectedProps<
  TypeProps,
  {},
  InjectedProps
> {
  render(): React.Fragment {
    const { t, actionDrawerStore } = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:error')}</h3>
            <Trans i18nKey="general:locations.messages.error_marked_as_default" parent="p">
              <u>{t('general:not')}</u>
            </Trans>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
